// Every key this site writes to browser storage. Listed on the Cookies page — keep both in sync.
export const STORAGE_KEYS = {
  local: ['pa_cookie_consent', 'pa_training_consent', 'pa_guest_usage', 'pa_theme', 'pa_chat'],
  session: ['pa_guest_results', 'pa_survey_prompted', 'pa_chunk_reload'],
  sessionPrefixes: ['pa_trial_notice_'],
};

/** Remove data tied to a person from this browser. The cookie choice is kept unless `everything` is set. */
export function clearPersonalStorage({ everything = false } = {}) {
  try {
    STORAGE_KEYS.local.filter((k) => everything || (k !== 'pa_cookie_consent' && k !== 'pa_theme')).forEach((k) => localStorage.removeItem(k));
  } catch (e) { /* storage unavailable */ }
  try {
    STORAGE_KEYS.session.forEach((k) => sessionStorage.removeItem(k));
    Object.keys(sessionStorage).filter((k) => STORAGE_KEYS.sessionPrefixes.some((p) => k.startsWith(p))).forEach((k) => sessionStorage.removeItem(k));
  } catch (e) { /* storage unavailable */ }
}
